import React from "react";
import Header from "../../component/Header/Header";
import Footer from "../../component/Footer/Footer";
import MapPage from "../../component/Map/Map";

const Mapus = () => (
  <>
    <Header />
    <div style={{ marginTop: 80, minHeight: "70vh" }}>
      <MapPage />
    </div>
  </>
);

export default Mapus;
